import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "asset",
  "use": "asset-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol viewBox=\"0 0 38 38\" id=\"asset\"><g class=\"cls-1\"><path class=\"cls-2\" d=\"M0 0h14.87v14.87H0zM23.13 0H38v14.87H23.13zM0 23.13h14.87V38H0zM23.13 23.13H38V38H23.13z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/asset.svg
// module id = sxCb
// module chunks = 1